import React from 'react';
import { SvgProps } from './icon.types';

function ViewsNumberIcon({ fillColor = '#2D3049', title, ...props }: SvgProps) {
  return (
    <svg version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title && <title>{title}</title>}
      <path
        d="M12 13a1 1 0 110-2 1 1 0 010 2m1-11v3.062c2.134.208 3.961 1.043 5.444 2.08l1.849-1.849 1.414 1.414-1.694 1.694C21.957 10.184 23 12 23 12s-4 7-11 7-11-7-11-7 1.043-1.816 2.987-3.599L2.293 6.707l1.414-1.414 1.849 1.849C7.039 6.105 8.866 5.27 11 5.062V2h2zm-1 5c-4.506 0-7.665 3.29-9 4.995C4.343 13.696 7.525 17 12 17c4.506 0 7.665-3.29 9-4.995C19.657 10.304 16.475 7 12 7zm0 2a3 3 0 110 6 3 3 0 010-6z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </svg>
  );
}

export { ViewsNumberIcon };
